import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"

class AreaInfo extends React.Component {
  static propTypes = {
    areaCode: PropTypes.number,
    area: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }),
    parent: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }),
  }

  render() {
    const { area, areaCode, parent } = this.props;
    if (!area && areaCode) {
      return <span className="AreaInfo">{areaCode}</span>;
    }

    return (
      <span>
        {parent && <div className={'parent'}>{parent?.name}</div>}
        <div>{area?.name}</div>
      </span>
    );
  }
}

function mapStateToProps(state, ownProps) {
  const areaCode = ownProps.areaCode
  let parentCode = undefined
  if (areaCode > 990000) {
    parentCode = areaCode - (areaCode % 1000)
  } else {
    parentCode = areaCode - (areaCode % 10000)
  }
  if (parentCode === areaCode) {
    parentCode = undefined
  }
  return {
    area: state.areaRepo[areaCode],
    parent: state.areaRepo[parentCode],
  }
}

export default connect(mapStateToProps)(AreaInfo)
